import viewportHelper from '@kissui/helpers/src/viewport.helpers'
import { stringifyForAttribute } from '@kissui/helpers/src/utils'

/**
 * Display labels
 * @param {Object[]} labels - List of labels
 * @param {string} labels[].name - Text
 * @param {string} labels[].bgColor - Background
 * @param {string} labels[].color - Font color
 * @param {HTMLElement} component - Apply css on component
 * @returns {String} - Render of labels
 */
export const renderLabels = ({ labels = [] }, component = null) => {
    if (!component || !labels || !labels.length) {
        return ''
    }

    if (component && labels.length) {
        component.classList.add('has-labels')
    }

    const direction = viewportHelper.is.mobile ? 'row' : 'column'
    const data = stringifyForAttribute({ labels })

    return `<nb-card-labels data="${data}" direction="${direction}"></nb-card-labels>`
}
